<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { INSTANCE_OF } from "@peerdb/peerdb/core"
import NavbarShortcut from "@peerdb/peerdb/partials/NavbarShortcut"

import { ARTIST, EXHIBITION } from "@/classes"
import { encodeQuery } from "@peerdb/peerdb/utils"

defineProps<{
  home: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <NavbarShortcut id="navbarlinks-link-exhibitions" :query="encodeQuery({ [INSTANCE_OF]: EXHIBITION })">{{ t("navbar.exhibitions") }}</NavbarShortcut>
  <NavbarShortcut id="navbarlinks-link-artists" :query="encodeQuery({ [INSTANCE_OF]: ARTIST })">{{ t("navbar.artists") }}</NavbarShortcut>
</template>
